import IconTooltip from './IconTooltip';

export default IconTooltip;
